import React, { useMemo } from 'react';

import { snackbar } from '@occc-app/design-system';
import { TableRowActionsMenu, useConfirmDialog } from '@occc/ui-design-system';
import { useOfferDeleteMutation } from '@occc-app/dataAccessLayer/offer/mutations';
import { ArchiveConfirmDialog } from '@occc-app/routes/CampaignComponents/components/ArchiveConfirmDialog';

interface CampaignComponentsTableRowActionsContainerProps {
  offerId: string;
  name: string;
  disabled?: boolean;
}

export const CampaignComponentsTableRowActionsContainer: React.FC<
  CampaignComponentsTableRowActionsContainerProps
> = ({ offerId, name, disabled }) => {
  const onDeleteComplete = () => {
    snackbar.success('Offer has been archived.');
  };
  const [offerDelete, { loading: isArchiveInProgress }] = useOfferDeleteMutation({
    onCompleted: onDeleteComplete,
    refetchQueries: ['campaignComponents'],
  });

  const onConfirm = () =>
    offerDelete({
      variables: { id: offerId },
    });

  const { open, setOpen, onCloseButtonClick, onConfirmButtonClick } = useConfirmDialog({
    onConfirm,
    shouldStopEventPropagation: true,
  });

  const menuItems = useMemo(
    () => [
      {
        label: 'Archive Component',
        onClick: () => setOpen(true),
        dataTestId: 'archive',
        disabled: isArchiveInProgress,
      },
    ],
    [setOpen, isArchiveInProgress],
  );

  return (
    <>
      <TableRowActionsMenu menuItems={menuItems} disabled={disabled || isArchiveInProgress} />
      <ArchiveConfirmDialog
        open={open}
        componentName={name}
        isArchiving={isArchiveInProgress}
        onClose={onCloseButtonClick}
        onConfirm={onConfirmButtonClick}
      />
    </>
  );
};
